var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmap1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 83,
    viewBox: "0 0 94 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4946 47.7836C75.8508 66.2147 93.6861 77.6244 93.1988 79.8673C92.7115 82.1103 73.9016 75.1864 53.045 76.4542C32.0909 77.6244 9.18767 86.9862 2.36543 81.0376C-4.55428 75.0889 4.80194 53.9273 16.3023 34.4235C27.8027 14.8222 41.4472 -3.21883 48.7567 0.486892C56.0663 4.09509 57.0409 29.45 66.4946 47.7836Z",
    fill: "#FF583D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5066 54.2834H36.4826V47.0834H32.8186V45.0354H33.5866C34.5999 45.0354 35.3519 44.8808 35.8426 44.5714C36.3439 44.2514 36.7066 43.7661 36.9306 43.1154H39.5066V54.2834ZM41.68 51.3874H44.992V54.2834H41.68V51.3874Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap1);
export default __webpack_public_path__ + "static/media/Roadmap1.dc3eb7a50c7dd0308b8560bedb5f5454.svg";
export { ForwardRef as ReactComponent };